module.exports = __webpack_public_path__ + "static/media/B2.524c2f68.jpg";